module.exports = __webpack_public_path__ + "img/foodics-f5.368fc11e.png";